import { useEffect, useState } from 'react';
import { Typography } from 'src/components/new/Typography';

const TrailingTwelveMonths = () => {
  const [ttm, setTtm] = useState({ start: '', end: '' });

  useEffect(() => {
    const calculateTTM = () => {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setFullYear(endDate.getFullYear() - 1);
      startDate.setDate(startDate.getDate() + 1);

      const formatDate = (date: Date) => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

      setTtm({
        start: formatDate(startDate),
        end: formatDate(endDate),
      });
    };

    calculateTTM();
  }, []);

  return (
    <Typography sx={{ paddingY: 2 }}>
      Summary {ttm.start} - {ttm.end}
    </Typography>
  );
};

export default TrailingTwelveMonths;
